import { useEffect } from 'react';
import { isPetLeadFlow, trackFunnelStep } from '../utils/analytics';

function VerifyEmailSuccessPage() {
  useEffect(() => {
    if (isPetLeadFlow()) {
      trackFunnelStep('email_verified');
    }
  }, []);

  return (
    <div className="container" style={{ maxWidth: '600px', margin: '2rem auto' }}>
      <div className="card">
        <div className="card-header">Email Verified</div>
        <div style={{ padding: '1rem' }}>
          <p style={{ marginTop: 0 }}>
            Your email has been successfully verified. You can now sign in using your email and password.
          </p>
          <a
            href="/login"
            className="btn btn-primary"
            style={{ display: 'inline-block', marginTop: '1rem' }}
          >
            Go to Login
          </a>
        </div>
      </div>
    </div>
  );
}

export default VerifyEmailSuccessPage;


